<template>
  <div>
    <div :style="{width: '100%'}">

      <v-tabs background-color="transparent"
              centered
              height="65">

        <v-tab exact
               to="/gifty">
          <v-icon left>mdi-gift</v-icon>
          Récompenses
        </v-tab>

        <v-tab exact
               to="/gifty/liaisons">
          <v-icon left>mdi-map-marker-distance</v-icon>
          Pos liés à Gifty
        </v-tab>

      </v-tabs>
    </div>
  </div>
</template>

<script>
export default {}
</script>

<style scoped>

</style>